import { Injectable } from '@angular/core';

import { createEffect, Actions, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, withLatestFrom, filter, catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { UsersListService } from '@apps/auth/domain/users-list.service';
import { IAuroraState } from '@apps/aurora.state';
import { User } from '@apps/auth/domain/models/back';
import { IdenticonService } from '@apps/auth/api/identicon.service';

import * as fromBackAuthStoreActions from './users-internal.actions';
import { getUsersInternalIsDataValid, getUsersInternalQueryString } from './users-internal.selectors';

@Injectable()
export class BackAuthUsersInternalEffects
{
    constructor (
        private actions: Actions,
        private usersListService: UsersListService,
        private identiconService: IdenticonService,
        private store: Store<IAuroraState>
    )
    { }

    backAuthUsersInternalODataRequested = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(fromBackAuthStoreActions.BackAuthUsersInternalODataRequested),
                    withLatestFrom(
                        this.store.select(getUsersInternalIsDataValid),
                        this.store.select(getUsersInternalQueryString),
                        (_, valid, qs) => ({
                            valid,
                            qs
                        })
                    ),
                    filter((params) => !params.valid),
                    switchMap((params) =>
                        this.usersListService.getUsers(params.qs)
                            .pipe(
                                map((users: User[]) =>
                                    fromBackAuthStoreActions.BackAuthUsersInternalODataLoaded({ users })
                                ),
                                catchError((err: any) =>
                                    of(fromBackAuthStoreActions.BackAuthUsersInternalODataFailed({ err }))
                                )
                            )
                    )
                ),
        { dispatch: true }
    );

    // backAuthUsersInternalIdenticonRequested = createEffect(
    //     (): Observable<Update<User>> =>
    //         this.actions
    //             .pipe(
    //                 ofType(fromBackAuthStoreActions.BackAuthUsersInternalIdenticonRequested),
    //                 map((params: any): string[] =>
    //                     params.userNames
    //                 ),
    //                 withLatestFrom(this.store.select(getAllUsersInternal)),
    //                 filter(([, users]: [string[], User[]]): boolean =>
    //                     users.length !== 0
    //                 ),
    //                 take(1),
    //                 map(([userNames, users]: [string[], User[]]): User[] =>
    //                     users.filter((user: User): boolean =>
    //                         userNames.includes(user.userName)
    //                     )
    //                 ),
    //                 concatAll(),
    //                 mergeMap((user: User): Observable<Update<User>> =>
    //                     this.identiconService.getDataUrl(user.email)
    //                         .pipe(
    //                             take(1),
    //                             map((dataUrl: string): Update<User> =>
    //                                 ({
    //                                     id: user.id,
    //                                     changes: {
    //                                         identiconDataUrl: dataUrl
    //                                     }
    //                                 } as Update<User>)
    //                             ),
    //                             tap((xyz: Update<User>): void =>
    //                                 this.store.dispatch(fromBackAuthStoreActions.BackAuthUsersInternalIdenticonSucceeded({ user: xyz }))
    //                             )
    //                         )
    //                 )
    //             ),
    //     { dispatch: false }
    // );
}
